// extracted by mini-css-extract-plugin
export var container = "_8z-1";
export var cornerButtonContainer = "_8z-5";
export var disabled = "_8z-2";
export var fileContainer = "_8z-4";
export var hiddenInput = "_8z-3";
export var widthContainer = "_8z-0";